// Navigation/Navbar.js
import React from "react";
import { MdDarkMode, MdLightMode } from "react-icons/md";
import resume from "../Assets/resume.pdf";

export default function Navbar({ isDarkMode, onToggleDarkMode }) {
  return (
    <header className="app-navbar fixed inset-x-0 top-0 z-50 border-b border-slate-200 bg-[#f8fafc] shadow-sm transition-colors duration-300 dark:border-slate-800 dark:bg-slate-950 dark:shadow-slate-900/30">
      <nav className="max-w-5xl mx-auto px-2 sm:px-4 py-3 sm:py-4 flex flex-wrap justify-center items-center gap-2 sm:gap-6 text-[#547792] text-sm font-semibold dark:text-[#b8d5e6]">
        {[
          "About",
          "Experience",
          "Projects",
          "Skills",
          "Education",
          "Contact"
        ].map((item, idx) => (
          <button
            key={item}
            onClick={() => {
              let sectionId = item.toLowerCase();
              if (sectionId === 'projects') sectionId = 'work';
              if (sectionId === 'skills') sectionId = 'skills';
              if (sectionId === 'education') sectionId = 'education';
              if (sectionId === '06.contact' || sectionId === 'contact') sectionId = 'contact';
              document
                .getElementById(sectionId)
                ?.scrollIntoView({ behavior: "smooth", block: "start" });
            }}
            className="text-[#547792] transition hover:text-orange-500 dark:text-[#b8d5e6] dark:hover:text-[#F59E0B]"
          >
            <span className="text-[#94B4C1] dark:text-[#94B4C1]">{`0${idx + 1}.`}</span> {item}
          </button>
        ))}
        <a
          href={resume}
          target="_blank"
          rel="noopener noreferrer"
          className="border border-[#547792] px-3 py-1 rounded transition whitespace-nowrap hover:border-transparent hover:bg-orange-500 hover:text-[#F1F0E8] dark:border-[#b8d5e6] dark:text-slate-100 dark:hover:border-[#F59E0B] dark:hover:bg-[#F59E0B]"
        >
          Resume
        </a>
        <button
          type="button"
          onClick={onToggleDarkMode}
          className="inline-flex h-9 w-9 items-center justify-center bg-transparent transition"
          aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
          title={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
        >
          {isDarkMode ? (
            <MdLightMode className="text-xl text-[#F59E0B] transition" aria-hidden="true" />
          ) : (
            <MdDarkMode className="text-xl text-[#547792] transition" aria-hidden="true" />
          )}
        </button>
      </nav>
    </header>
  );
}
